export function search(searchTerm, fullData, searchFields) {
  if (searchTerm === "" || searchTerm === null || searchTerm.length < 3) return [...fullData];

  return fullData.filter((item) => {
    return searchTerm
      .toLowerCase()
      .split(" ")
      .every((word) => {
        return searchFields.some((field) => {
          return item[[field]]?.toLowerCase().includes(word);
        });
      });
  });
}
